import {
    Col,
    Row,
    Input,
    Form,
    Card,
    Collapse,
    Select,
    Button,
    Switch,
    DatePicker,
    Space,
    type DatePickerProps,
    Tooltip,
} from 'antd'
import commonStyles from '../../../../Utils/Common.less'
import soleTraderNewStyles from '../../../../Less/Clients/RegisteredClients/SoleTrader/SoleTraderNew.less'
import { connect, useDispatch } from 'react-redux'
import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { GetCategoryDropDownList } from '../../../../Services/GroupAndPartners'
import type {
    SoleTraderNewStateInterface,
    SoleTraderCreateFormDataInterface,
} from '../../../../Types/Client/RegisteredClients/SoleTrader'
import { GetCountryList } from '../../../../Services/Common'
import { saveSoleTrader } from '../../../../Services/SoleTrader'
import { SaveOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
// import { validateDate } from '../../../../Utils/ValidateDate'
import { validateName } from '../../../../Utils/Common'
import { type ListFrontEndInterface } from '../../../../Types/CommonType'
import PostCodeInput from '../../../../Components/PostCodeInput'
import InputFieldNINumber from '../../../../Components/InputNINO'

const SoleTraderNew = (
    props: SoleTraderNewStateInterface
): React.ReactElement => {
    const { categoryDropDownList, countryList } = props
    const location = useLocation()
    const onbordingId = location.state?.onbordingId
    const [form] = Form.useForm()
    const [collapseOne, SetCollapseOne] = useState<string[] | string>(['1'])
    const [collapseTwo, SetCollapseTwo] = useState<string[] | string>([])
    const navigate = useNavigate()

    const [selectedDateAp, setSelectedDate] = useState<string>('')
    const dispatch = useDispatch()
    const hasFetchedOnce = useRef(false)
    const [changeHomeAddress, setHomeAddress] = useState(false)
    const [changeBusinessAddress, setchangeBusinessAddress] = useState(false)
    const [address, setAddress] = useState({
        line_1: '',
        line_2: '',
        line_3: '',
        post_town: '',
        postcode: '',
        country: '',
    })
    useEffect(() => {
        const countryData = countryList?.find(
            (data: ListFrontEndInterface) =>
                data.label === address?.country?.toUpperCase()
        )
        if (address.line_1 !== '') {
            if (collapseTwo === '2') {
                const AddressData = {
                    busAddress1: address.line_1,
                    busAddress2: address.line_2,
                    busTown: address.post_town,
                    busCountry: countryData?.label ?? '',
                    busPostCode: address.postcode,
                }
                form.setFieldsValue(AddressData)
            } else if (collapseTwo === '3') {
                const AddressData = {
                    corrAddress1: address.line_1,
                    corrAddress2: address.line_2,
                    corrTown: address.post_town,
                    corrCountry: countryData?.label ?? '',
                    corrPostCode: address.postcode,
                }
                form.setFieldsValue(AddressData)
            } else {
                const AddressData = {
                    homeAddressOne: address.line_1,
                    homeAddressTwo: address.line_2,
                    homeTown: address.post_town,
                    homeCountry: countryData?.label ?? '',
                    homePostCode: address.postcode,
                }
                form.setFieldsValue(AddressData)
            }
        }
    }, [address])

    useEffect(() => {
        if (!hasFetchedOnce.current) {
            hasFetchedOnce.current = true
            return
        }
        GetCategoryDropDownList(dispatch)
        GetCountryList(dispatch)
    }, [dispatch])

    const customizeRequiredMark = (
        label: React.ReactNode,
        { required }: { required: boolean }
    ): React.ReactElement => (
        <>
            {label}
            &nbsp;
            {required && <span className={commonStyles.requireIcon}>*</span>}
        </>
    )

    const saveCallBack = (data: SoleTraderCreateFormDataInterface): void => {
        localStorage.setItem('solderTapId', '1')

        navigate(
            onbordingId === 1
                ? '/clients/registered-clients/soletrader-view'
                : '/clients/onboarding-clients/soletrader-view',
            {
                state: { SoleTraderData: data, onbordingId },
            }
        )
    }

    const onSaveSoleTrader = (
        data: SoleTraderCreateFormDataInterface
    ): void => {
        void saveSoleTrader(dispatch, data, saveCallBack)
    }

    const collapseOneOnChange = (data: string | string[]): void => {
        SetCollapseOne(data)
    }

    const collapseTwoOnChange = (data: string | string[]): void => {
        SetCollapseTwo(data)
    }

    useEffect(() => {
        form.setFieldValue('dateOfBirth', selectedDateAp)
    }, [selectedDateAp])

    const onChange = (dateOfBirth: DatePickerProps['value']): void => {
        if (dateOfBirth != null) {
            const isoDate = dateOfBirth.toISOString()
            setSelectedDate(isoDate)
            form.setFieldValue('dateOfBirth', isoDate)
            void form.validateFields(['dateOfBirth'])
        }
    }

    const initialDetails = (): React.ReactElement => {
        return (
            <div>
                <Form.Item
                    label="Client Category"
                    name="clientCategoryId"
                    initialValue={1}
                    rules={[
                        {
                            required: true,
                            message: 'Please Select Client Category',
                        },
                    ]}
                >
                    <Select
                        placeholder="Please select"
                        options={[...categoryDropDownList]}
                        filterOption={(input, option) =>
                            option?.label
                                ?.toLowerCase()
                                .includes(input.toLowerCase()) ?? false
                        }
                        allowClear
                        showSearch
                        defaultValue={1}
                    />
                </Form.Item>
                <Form.Item label="Title" name="tittle" initialValue={'UNKNOWN'}>
                    <Select
                        allowClear
                        placeholder="Please select title"
                        onChange={() => {}}
                        filterOption={(input, option) =>
                            typeof option?.children === 'string' && // Ensure option.children is a string
                            (option.children as string)
                                .toLowerCase()
                                .includes(input.toLowerCase())
                        }
                        showSearch
                    >
                        <Select.Option value="UNKNOWN">Unknown</Select.Option>
                        <Select.Option value="MR.">MR.</Select.Option>
                        <Select.Option value="MISS.">MISS.</Select.Option>
                        <Select.Option value="MRS.">MRS.</Select.Option>
                        <Select.Option value="MS.">MS.</Select.Option>
                        <Select.Option value="DR.">DR.</Select.Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    label="First Name"
                    name="firstName"
                    rules={[
                        {
                            required: true,
                            message: 'Please Enter First Name',
                        },
                        {
                            validator: async (rule, value) =>
                                await validateName(rule, value, 'First Name'),
                        },
                    ]}
                >
                    <Input maxLength={100} allowClear />
                </Form.Item>
                <Form.Item
                    label="Middle Name"
                    name="middleName"
                    rules={[
                        {
                            validator: async (rule, value) =>
                                await validateName(rule, value, 'Middle Name'),
                        },
                    ]}
                >
                    <Input maxLength={100} allowClear />
                </Form.Item>
                <Form.Item
                    label="Surname"
                    name="surName"
                    rules={[
                        {
                            required: true,
                            message: 'Please Enter Surname',
                        },
                        {
                            validator: async (rule, value) =>
                                await validateName(rule, value, 'Surname'),
                        },
                    ]}
                >
                    <Input maxLength={100} allowClear />
                </Form.Item>
                <Form.Item
                    label="Nature Of Business"
                    name="natureOfBusiness"
                    rules={[
                        {
                            required: true,
                            message: 'Please Enter First Name',
                        },
                    ]}
                >
                    <Input maxLength={100} allowClear />
                </Form.Item>
                <Form.Item
                    label="Business Trading Name"
                    name="businessTradingName"
                    rules={[
                        {
                            required: true,
                            message: 'Please Enter Business Trading Name',
                        },
                    ]}
                >
                    <Input maxLength={100} allowClear />
                </Form.Item>
                <Form.Item label="Individual UTR" name="individualUTR">
                    <Input maxLength={20} allowClear />
                </Form.Item>
            </div>
        )
    }

    const personalDetails = (): React.ReactElement => {
        return (
            <div>
                <Form.Item
                    label="Date Of Birth"
                    name="dateOfBirth"
                    // rules={[
                    //     {
                    //         validator: async (_, value) =>
                    //             await validateDate(value),
                    //     },
                    // ]}
                >
                    <Space direction="vertical" size={12}>
                        <DatePicker
                            allowClear
                            onChange={onChange}
                            value={
                                selectedDateAp.length > 0
                                    ? dayjs(selectedDateAp)
                                    : null
                            }
                            format="DD/MM/YYYY"
                            className={commonStyles.dateWidth}
                            disabledDate={(current) =>
                                current !== null &&
                                current > dayjs().endOf('day')
                            }
                        />
                    </Space>
                </Form.Item>
                {/* <Form.Item label="NI Number" name="niNumber">
                    <Input allowClear maxLength={9} />
                </Form.Item> */}
                <InputFieldNINumber name="niNumber" form={form} />
                <Form.Item label="Nationality" name="nationality">
                    <Input allowClear maxLength={100} />
                </Form.Item>
                <Form.Item
                    label="Mobile Number"
                    name="mobileNumber"
                    rules={[
                        {
                            required: true,
                            message: 'Please Enter Mobile Number',
                        },
                        {
                            pattern: /^\d{10,15}$/,
                            message: 'Mobile Number must be 10-15 digits!',
                        },
                    ]}
                >
                    <Input allowClear minLength={10} maxLength={15} />
                </Form.Item>
                <Form.Item
                    label="Home Number"
                    name="homeNumber"
                    rules={[
                        {
                            pattern: /^\d{10,15}$/,
                            message: 'Home Number must be 10-15 digits!',
                        },
                    ]}
                >
                    <Input allowClear minLength={10} maxLength={15} />
                </Form.Item>
                <Form.Item
                    label="Work Number"
                    name="workNumber"
                    rules={[
                        {
                            pattern: /^\d{10,15}$/,
                            message: 'Work Number must be 10-15 digits!',
                        },
                    ]}
                >
                    <Input allowClear minLength={10} maxLength={15} />
                </Form.Item>
                <Form.Item
                    label="Email Address"
                    name="emailAddress"
                    rules={[
                        {
                            required: true,
                            message: 'Please Enter Email Address',
                        },
                        {
                            pattern:
                                /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                            message: 'Please enter a valid Email Address!',
                        },
                    ]}
                >
                    <Input allowClear maxLength={100} />
                </Form.Item>
                <Form.Item
                    label="Alternative Email Address"
                    name="alternativeEmailAddress"
                    rules={[
                        {
                            pattern:
                                /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                            message: 'Please enter a valid Email Address!',
                        },
                    ]}
                >
                    <Input allowClear maxLength={100} />
                </Form.Item>
            </div>
        )
    }

    const homeAddress = (): React.ReactElement => {
        return (
            <div>
                <Form.Item
                    label="Address 1"
                    name="homeAddressOne"
                    rules={[
                        {
                            required: true,
                            message: 'Please Enter Address1',
                        },
                    ]}
                >
                    <Input allowClear maxLength={200} />
                </Form.Item>
                <Form.Item label="Address 2" name="homeAddressTwo">
                    <Input allowClear maxLength={200} />
                </Form.Item>
                <Form.Item
                    label="Town"
                    name="homeTown"
                    rules={[
                        {
                            required: true,
                            message: 'Please Enter Town',
                        },
                    ]}
                >
                    <Input allowClear maxLength={50} />
                </Form.Item>
                <Form.Item
                    label="Country"
                    name="homeCountry"
                    initialValue="UNITED KINGDOM"
                    rules={[
                        {
                            required: true,
                            message: 'Please select Country',
                        },
                    ]}
                >
                    <Select
                        allowClear
                        showSearch
                        placeholder="Please select"
                        onChange={() => {}}
                        optionFilterProp="children"
                        options={countryList?.map((data: { label: string }) => {
                            return {
                                id: data.label,
                                value: data.label,
                                label: data.label,
                            }
                        })}
                        filterOption={(input, option) =>
                            option?.label
                                ?.toLowerCase()
                                .includes(input.toLowerCase()) ?? false
                        }
                    />
                </Form.Item>
                <PostCodeInput
                    name="homePostCode"
                    label="Post Code"
                    reuireMessage="Please Enter Post Code"
                    placeHolder={''}
                    setAddressDetails={setAddress}
                />
            </div>
        )
    }

    const onChangeBAHome = (checked: boolean): void => {
        let busAddress1 = ''
        let busAddress2 = ''
        let busTown = ''
        let busCountry = ''
        let busPostCode = ''
        if (checked) {
            busAddress1 = form.getFieldValue('homeAddressOne')
            busAddress2 = form.getFieldValue('homeAddressTwo')
            busTown = form.getFieldValue('homeTown')
            busCountry = form.getFieldValue('homeCountry')
            busPostCode = form.getFieldValue('homePostCode')
        }
        form.setFieldValue('busAddress1', busAddress1)
        form.setFieldValue('busAddress2', busAddress2)
        form.setFieldValue('busTown', busTown)
        form.setFieldValue('busCountry', busCountry)
        form.setFieldValue('busPostCode', busPostCode)
        void form.validateFields()
    }

    const businessAddress = (): React.ReactElement => {
        return (
            <div>
                <div className={commonStyles.marginBottom10}>
                    <Switch size="small" onChange={onChangeBAHome} />
                    &nbsp;
                    <label className={commonStyles.colorGray}>
                        Same as Home
                    </label>
                </div>
                <Form.Item
                    label="Address 1"
                    name="busAddress1"
                    rules={[
                        {
                            required: true,
                            message: 'Please Enter Address1',
                        },
                    ]}
                >
                    <Input allowClear maxLength={200} />
                </Form.Item>
                <Form.Item label="Address 2" name="busAddress2">
                    <Input allowClear maxLength={200} />
                </Form.Item>
                <Form.Item
                    label="Town"
                    name="busTown"
                    rules={[
                        {
                            required: true,
                            message: 'Please Enter Town',
                        },
                    ]}
                >
                    <Input allowClear maxLength={50} />
                </Form.Item>
                <Form.Item
                    label="Country"
                    name="busCountry"
                    initialValue="UNITED KINGDOM"
                    rules={[
                        {
                            required: true,
                            message: 'Please select Country',
                        },
                    ]}
                >
                    <Select
                        allowClear
                        showSearch
                        placeholder="Please select"
                        onChange={() => {}}
                        optionFilterProp="children"
                        options={countryList?.map((data: { label: string }) => {
                            return {
                                id: data.label,
                                value: data.label,
                                label: data.label,
                            }
                        })}
                        filterOption={(input, option) =>
                            option?.label
                                ?.toLowerCase()
                                .includes(input.toLowerCase()) ?? false
                        }
                    />
                </Form.Item>

                <PostCodeInput
                    name="busPostCode"
                    label="Post Code"
                    reuireMessage="Please Enter Post Code"
                    placeHolder={''}
                    setAddressDetails={setAddress}
                />
            </div>
        )
    }

    const onChangeCAHome = (checked: boolean): void => {
        setHomeAddress(checked)
        setchangeBusinessAddress(false)
        let corrAddress1 = ''
        let corrAddress2 = ''
        let corrTown = ''
        let corrCountry = ''
        let corrPostCode = ''
        if (checked) {
            corrAddress1 = form.getFieldValue('homeAddressOne')
            corrAddress2 = form.getFieldValue('homeAddressTwo')
            corrTown = form.getFieldValue('homeTown')
            corrCountry = form.getFieldValue('homeCountry')
            corrPostCode = form.getFieldValue('homePostCode')
        }
        form.setFieldValue('corrAddress1', corrAddress1)
        form.setFieldValue('corrAddress2', corrAddress2)
        form.setFieldValue('corrTown', corrTown)
        form.setFieldValue('corrCountry', corrCountry)
        form.setFieldValue('corrPostCode', corrPostCode)
        void form.validateFields()
    }

    const onChangeCABusiness = (checked: boolean): void => {
        setchangeBusinessAddress(checked)
        setHomeAddress(false)
        let corrAddress1 = ''
        let corrAddress2 = ''
        let corrTown = ''
        let corrCountry = ''
        let corrPostCode = ''
        if (checked) {
            corrAddress1 = form.getFieldValue('busAddress1')
            corrAddress2 = form.getFieldValue('busAddress2')
            corrTown = form.getFieldValue('busTown')
            corrCountry = form.getFieldValue('busCountry')
            corrPostCode = form.getFieldValue('busPostCode')
        }
        form.setFieldValue('corrAddress1', corrAddress1)
        form.setFieldValue('corrAddress2', corrAddress2)
        form.setFieldValue('corrTown', corrTown)
        form.setFieldValue('corrCountry', corrCountry)
        form.setFieldValue('corrPostCode', corrPostCode)
        void form.validateFields()
    }

    const correspondAddress = (): React.ReactElement => {
        return (
            <div>
                <div className={soleTraderNewStyles.cpAddressMain}>
                    <div className={commonStyles.margintRight100}>
                        <Switch
                            size="small"
                            checked={changeHomeAddress}
                            onChange={onChangeCAHome}
                        />
                        &nbsp;
                        <label className={commonStyles.colorGray}>
                            Same as Home
                        </label>
                    </div>
                    <div>
                        <Switch
                            size="small"
                            checked={changeBusinessAddress}
                            onChange={onChangeCABusiness}
                        />
                        &nbsp;
                        <label className={commonStyles.colorGray}>
                            Same as Business
                        </label>
                    </div>
                </div>
                <Form.Item
                    label="Address 1"
                    name="corrAddress1"
                    rules={[
                        {
                            required: true,
                            message: 'Please Enter Address1',
                        },
                    ]}
                >
                    <Input allowClear maxLength={200} />
                </Form.Item>
                <Form.Item label="Address 2" name="corrAddress2">
                    <Input allowClear maxLength={200} />
                </Form.Item>
                <Form.Item
                    label="Town"
                    name="corrTown"
                    rules={[
                        {
                            required: true,
                            message: 'Please Enter Town',
                        },
                    ]}
                >
                    <Input allowClear maxLength={50} />
                </Form.Item>
                <Form.Item
                    label="Country"
                    name="corrCountry"
                    initialValue="UNITED KINGDOM"
                    rules={[
                        {
                            required: true,
                            message: 'Please select Country',
                        },
                    ]}
                >
                    <Select
                        allowClear
                        showSearch
                        placeholder="Please select"
                        onChange={() => {}}
                        optionFilterProp="children"
                        options={countryList?.map((data: { label: string }) => {
                            return {
                                id: data.label,
                                value: data.label,
                                label: data.label,
                            }
                        })}
                        filterOption={(input, option) =>
                            option?.label
                                ?.toLowerCase()
                                .includes(input.toLowerCase()) ?? false
                        }
                    />
                </Form.Item>

                <PostCodeInput
                    name="corrPostCode"
                    label="Post Code"
                    reuireMessage="Please Enter Post Code"
                    placeHolder={''}
                    setAddressDetails={setAddress}
                />
            </div>
        )
    }

    const onFinishFailed = ({ errorFields }: any): void => {
        SetCollapseOne(['1', '2'])
        SetCollapseTwo(['1', '2', '3'])
    }
    return (
        <>
            <div>
                <h2>Sole Trader Registration</h2>
            </div>
            <Card className={commonStyles.card}>
                <Form
                    name="complex-form"
                    layout={'vertical'}
                    autoComplete="off"
                    form={form}
                    requiredMark={customizeRequiredMark}
                    onFinish={onSaveSoleTrader}
                    onFinishFailed={onFinishFailed}
                >
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item label="Client Type">
                                <Input disabled value={'Sole Trader'} />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item label="Client No" name="clientNumber">
                                <Input disabled />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={12}>
                            <Form.Item label="Client Name">
                                <Input disabled />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                label="Business Trading Name"
                                name="businessTradingName"
                            >
                                <Input disabled />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <h3>Basic Information</h3>
                    </Row>
                    <div className={commonStyles.flexDirectionRow}>
                        <div className={soleTraderNewStyles.collapseFirst}>
                            <Collapse
                                activeKey={collapseOne}
                                onChange={collapseOneOnChange}
                                bordered={true}
                            >
                                <Collapse.Panel
                                    key="1"
                                    header="Initial Details"
                                    forceRender
                                >
                                    {initialDetails()}
                                </Collapse.Panel>
                                <Collapse.Panel
                                    key="1"
                                    header="Personal Details"
                                    forceRender
                                >
                                    {personalDetails()}
                                </Collapse.Panel>
                            </Collapse>
                        </div>
                        <div className={soleTraderNewStyles.collapseSecond}>
                            <Collapse
                                activeKey={collapseTwo}
                                onChange={collapseTwoOnChange}
                                bordered={true}
                            >
                                <Collapse.Panel
                                    key="1"
                                    header="Home Address"
                                    forceRender
                                >
                                    {homeAddress()}
                                </Collapse.Panel>
                                <Collapse.Panel
                                    key="2"
                                    header="Business Address"
                                    forceRender
                                >
                                    {businessAddress()}
                                </Collapse.Panel>
                                <Collapse.Panel
                                    key="3"
                                    header="Correspondence Address"
                                    forceRender
                                >
                                    {correspondAddress()}
                                </Collapse.Panel>
                            </Collapse>
                        </div>
                    </div>
                    &nbsp;
                    <Row gutter={16}>
                        <Col offset={21} span={1}>
                            <Tooltip title=" Save Basic Information">
                                <Button type="primary" htmlType="submit">
                                    <SaveOutlined />
                                </Button>
                            </Tooltip>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </>
    )
}

const mapStateToProps = (state: any): SoleTraderNewStateInterface => {
    return {
        categoryDropDownList: state.initial.categoryDropDownList,
        countryList: state.common.countryList,
    }
}

export default connect(mapStateToProps)(SoleTraderNew)
